import script from "./SkillsChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkillsChart.vue?vue&type=script&setup=true&lang=ts"

import "./SkillsChart.vue?vue&type=style&index=0&id=33b48ca2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b48ca2"]])

export default __exports__